import { useContext } from 'react'
import { useIntl } from 'react-intl'
import styled from 'styled-components'
import { rem } from 'polished'
import Image from 'components/Common/Image'
import { mediaQueryUp } from 'components/utils/breakpoint'
import { ProductReviewLogo } from 'components/Common/TrustIndicators/ProductReviewLogo'
import CSSBreakpoint from 'components/utils/CSSBreakpoint'
import GeoContext from 'contexts/geoContext'

const Root = styled.div`
  display: inline-flex;
  justify-content: center;
  flex-wrap: wrap;
  gap: ${rem(34)};

  ${mediaQueryUp.desktop} {
    justify-content: stretch;
    align-items: center;
    flex-wrap: nowrap;
  }
`

const Accreditation = styled(Image)`
  width: auto;
  height: ${rem(64)};
`

interface Props {
  showProductReviewWinner: boolean
  className?: string
}

function Accreditations({ showProductReviewWinner, className }: Props) {
  const { currentRegionCode } = useContext(GeoContext)
  const intl = useIntl()

  return (
    <Root className={className}>
      <Accreditation
        format="png"
        id="IATA_nsg6d6"
        alt={intl.formatMessage({
          id: 'rqcu359qMpZdgEe_iEZa',
          defaultMessage: 'IATA',
        })}
      />
      {currentRegionCode === 'AU' && <Accreditation
        format="png"
        id="x2rsn9482n5gxo9jylyi"
        alt={intl.formatMessage({
          id: 'ur2jRUNeVcHSkVFpdmsB',
          defaultMessage: 'ATIA',
        })}
      />}
      {currentRegionCode === 'GB' && <Accreditation
        format="jpg"
        id="atol-11711-logo"
        alt={intl.formatMessage({
          id: 'akchNrlN7zVKqbWgATeT',
          defaultMessage: 'ATOL',
        })}
      />}
      {showProductReviewWinner && <>
        <CSSBreakpoint max="mobile">
          <ProductReviewLogo variant="multi-year" width="165" />
        </CSSBreakpoint>
        <CSSBreakpoint min="tablet">
          <ProductReviewLogo variant="multi-year" width="200" />
        </CSSBreakpoint>
      </>}
    </Root>
  )
}

export default Accreditations
